import React, { useEffect, useState } from "react";
import { ElementsConsumer, CardElement } from "@stripe/react-stripe-js";
import CardSection from "./CardSection";
import Loader3Orange from "../../general/Loader3Orange";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { signUpModalClosed } from "../../store/components";
import { addNewBrokerage, isSignupResponse } from "../../store/broker";
import { Button, Col } from "reactstrap";
import "./signup.css";

export function CheckoutForm(props) {
  const signUpResponse = useSelector(isSignupResponse);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const handlePayment = (data) => {
    setIsLoading(true);
    const token = { token: data };
    if (token) {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { stripe, elements, data } = props;
    if (!stripe || !elements) {
      return;
    }
    const card = elements.getElement(CardElement);
    const result = await stripe.createToken(card);

    props.handleSubmit(result);
  };
  return (
    <>
      <div>
        <div className="product-info"></div>
        <form onSubmit={handleSubmit}>
          <CardSection />
          <button disabled={!props.stripe} className="btn-pay">
            Add Card Detail
          </button>
        </form>
      </div>
    </>
  );
}
export default function InjectedCheckoutForm(props) {
  return (
    <ElementsConsumer>
      {({ stripe, elements, data }) => (
        <CheckoutForm
          stripe={stripe}
          elements={elements}
          data={props.data}
          handleSubmit={props.handleSubmit}
        />
      )}
    </ElementsConsumer>
  );
}
